
export default {
    props: {
        mode: {
            type: String,
            default: 'inline',
        },
        value: {
            type: Number,
            default: 0
        },
        merge: {
            type: Object,
            default: () => ({})
        }
    },
}
